export default {
  whitelistedUsers: [],
}
